import React, { useState } from 'react';
import { useStudioStore } from '../../stores/useStudioStore';
import { ResultRow } from './ResultRow';

type ResultsTab = 'queue' | 'approved' | 'discarded';

export const PanelResults: React.FC = () => {
  const { mainQueue, clearMainQueue } = useStudioStore();
  const [activeTab, setActiveTab] = useState<ResultsTab>('queue');

  // Filter based on review state
  const queue = mainQueue.filter(p => p.reviewState === 'pending' && p.status !== 'pending');
  const approved = mainQueue.filter(p => p.reviewState === 'approved');
  const discarded = mainQueue.filter(p => p.reviewState === 'discarded');

  const getVisibleProducts = () => {
    switch(activeTab) {
      case 'queue': return queue;
      case 'approved': return approved;
      case 'discarded': return discarded;
      default: return [];
    }
  };

  const visibleProducts = getVisibleProducts();

  return (
    <div className="panel-right">
      <div className="tabs-bar">
        <button 
          className={`tab-btn ${activeTab === 'queue' ? 'active' : ''}`} 
          onClick={() => setActiveTab('queue')}
        >
          Queue <span className="tab-badge">{queue.length}</span>
        </button>
        <button 
          className={`tab-btn ${activeTab === 'approved' ? 'active' : ''}`} 
          onClick={() => setActiveTab('approved')}
        >
          Approved <span className="tab-badge">{approved.length}</span>
        </button>
        <button 
          className={`tab-btn ${activeTab === 'discarded' ? 'active' : ''}`} 
          onClick={() => setActiveTab('discarded')}
        >
          Discarded <span className="tab-badge">{discarded.length}</span>
        </button>
        
        <div className="tabs-actions">
          {activeTab === 'approved' && approved.length > 0 && (
            <button className="action-btn green">↓ Save all approved (ZIP)</button>
          )}
          <button className="action-btn" onClick={clearMainQueue}>Clear all</button>
        </div>
      </div>

      <div className="results-area">
        {visibleProducts.length === 0 ? (
          <div className="empty-state">
            <div className="empty-icon">✦</div>
            <div className="empty-title">Nothing here yet</div>
            <div className="empty-sub">Upload a named folder in Panel B, write your prompt, then hit Generate all.</div>
          </div>
        ) : (
          visibleProducts.map(p => (
            <ResultRow key={p.id} product={p} />
          ))
        )}
      </div>
    </div>
  );
};
